import { transformConstants } from '../helpers';

const apiHealthEventConstants = transformConstants([]);

export { apiHealthEventConstants };
